import { useTranslation } from "react-i18next";
import { Loader, Select, type SelectProps } from "@mantine/core";
import { TenantType } from "src/graphql/generated/graphql";
import { checkCountryCode } from "src/utils/helpers";

import { useTenants } from "../../hooks/tenants";

export interface SelectRegionProps extends Partial<SelectProps> {
    label?: string;
    placeholder?: string;
    value?: string;
    onChange?(tenantId: string);
}

export const SelectRegion = ({ label, placeholder, value, onChange, ...rest }: SelectRegionProps) => {
    const { t } = useTranslation(["common"]);

    const { tenants, isLoadingTenants } = useTenants({
        type: [TenantType.Main],
    });

    return (
        <Select
            {...rest}
            label={label || label === null ? label : t("tenant_main")}
            placeholder={placeholder || t("tenant_main_select")}
            nothingFound={t("nothing_found")}
            icon={isLoadingTenants && <Loader size="sm" />}
            data={tenants.map((tenant) => ({
                value: tenant?.id,
                label: checkCountryCode(tenant?.id) ? t(`country_${tenant?.id}`) : tenant?.id,
            }))}
            value={value}
            onChange={onChange}
        />
    );
};
